define.alias("shared/components/shared/plan-recommendation/plan-card", "settings/components/shared/plan-recommendation/plan-card");